// extracted by mini-css-extract-plugin
module.exports = {"menuStyleMobile":"styles--menuStyleMobile--2PCST","menuStyle":"styles--menuStyle--wlqj4","paddingNotifiy":"styles--paddingNotifiy--3GuHx","hideMid":"styles--hideMid--bmlYo"};